import React from 'react';
import image1 from '../../../../../images/modules/module-2/6.png';
import './index.scss';

export const BannerContentTop = () => {
    return (
        <div className='runup-banner-top'>
            <img className='runup-banner-top__image' src={image1} alt='banner' />
            <div className='runup-banner-top__content'>
                <div className='runup-banner-top__title'>Train Smarter. Run Stronger.</div>
                <div className='runup-banner-top__text'>
                    Whether you’re a repeat marathoner or working up to conquering your first mile, Runner’s World is
                    your go-to source for all things training, nutrition, and gear to ensure you’re running at your
                    best. This is a community created by and for runners. We work with the best nutritionists and
                    trainers, test the best shoes and gear, and stay on top of the latest research and developments so
                    you can focus on what matters — your run. Your best miles are ahead, and we’re here to get you there
                    stronger, healthier, better.
                </div>
            </div>
        </div>
    );
};
